import { cn } from 'src/lib/utils';

type Props = {
  title: string;
  description: string;
  action: React.ReactNode;
  variant?: 'primary' | 'secondary';
};

const CallToActionBanner = ({ title, description, action, variant = 'primary' }: Props) => {
  return (
    <div
      className={cn('flex flex-col sm:items-center sm:flex-row p-6 rounded-lg shadow-sm gap-1.5', {
        'bg-primary': variant === 'primary',
        'bg-card border border-border': variant === 'secondary',
      })}
    >
      <div className="grow space-y-1">
        <h6 className="text-base font-semibold text-foreground">{title}</h6>
        <p
          className={cn('text-sm', {
            'text-foreground/80': variant === 'primary',
            'text-muted-foreground': variant === 'secondary',
          })}
        >
          {description}
        </p>
      </div>
      <div className="shrink-0 *:w-full sm:*:w-auto">{action}</div>
    </div>
  );
};

export default CallToActionBanner;
